import { ResourceName } from "@/types";

interface EditableKeys {
  key: string;
  name: string;
  type: string;
}

export const recordTypes: {
  id: string;
  name: string;
  editableKeys: EditableKeys[];
}[] = [
  {
    id: ResourceName.POLICIES,
    name: "Policies",
    editableKeys: [
      { key: "contract_basis", name: "Contract Basis", type: "string" },
      {
        key: "effective_start_date",
        name: "Effective Start Date",
        type: "date",
      },
      { key: "effective_end_date", name: "Effective End Date", type: "string" },
      { key: "status", name: "Status", type: "select" },
      // TODO: Any nested data either needs to have backend dot annotation support
      // TODO: or we need to set up the front end to replace the object in the update
      // aggregate_benefit nested object
      {
        key: "aggregate_benefit.aggregate_blended_premium",
        name: "Agg: Blended Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_composite_premium",
        name: "Agg: Composite Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_deductible",
        name: "Agg: Deductible",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_employee_plus_children_enrolled",
        name: "Agg: Children Enrolled",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_employee_plus_children_premium",
        name: "Agg: Children Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_employee_plus_spouse_enrolled",
        name: "Agg: Spouse Enrolled",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_employee_plus_spouse_premium",
        name: "Agg: Spouse Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_family_premium",
        name: "Agg: Family Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_individual_premium",
        name: "Agg: Individual Premium",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_stop_loss_individual_claim_limit",
        name: "Agg: SL Individual Limit",
        type: "number",
      },
      {
        key: "aggregate_benefit.aggregate_stop_loss_percentage_reimbursable",
        name: "Agg: SL Percentage Reimbursable",
        type: "number",
      },
      {
        key: "aggregate_benefit.contract_basis",
        name: "Agg: Contract Basis",
        type: "string",
      },
      {
        key: "aggregate_benefit.contract_type",
        name: "Agg: Contract Type",
        type: "string",
      },
      {
        key: "aggregate_benefit.covered_composite",
        name: "Agg: Covered Composite",
        type: "number",
      },
      {
        key: "aggregate_benefit.eligible_expenses_incurred_end_date",
        name: "Agg: Expenses Incurred End Date",
        type: "date",
      },
      {
        key: "aggregate_benefit.eligible_expenses_incurred_start_date",
        name: "Agg: Expenses Incurred Start Date",
        type: "date",
      },
      {
        key: "aggregate_benefit.eligible_expenses_paid_end_date",
        name: "Agg: Expenses Paid End Date",
        type: "date",
      },
      {
        key: "aggregate_benefit.eligible_expenses_paid_start_date",
        name: "Agg: Expenses Paid Start Date",
        type: "date",
      },
      {
        key: "aggregate_benefit.families_enrolled",
        name: "Agg: Families Enrolled",
        type: "number",
      },
      {
        key: "aggregate_benefit.individuals_enrolled",
        name: "Agg: Individuals Enrolled",
        type: "number",
      },
      {
        key: "aggregate_benefit.is_aggregate_deductible",
        name: "Agg: Is Aggregate Deductible",
        type: "boolean",
      },
      {
        key: "aggregate_benefit.maximum_annual_reimbursement",
        name: "Agg: Max Annual Reimbursement",
        type: "number",
      },
      {
        key: "aggregate_benefit.has_medical_coverage",
        name: "Agg: Medical Coverage",
        type: "boolean",
      },
      {
        key: "aggregate_benefit.medical_provider",
        name: "Agg: Medical Provider",
        type: "string",
      },
      {
        key: "aggregate_benefit.monthly_aggregate_spend_per_composite",
        name: "Agg: Monthly Agg Spend per Composite",
        type: "number",
      },
      {
        key: "aggregate_benefit.has_rx_coverage",
        name: "Agg: Has RX Coverage",
        type: "boolean",
      },
      {
        key: "aggregate_benefit.rx_provider",
        name: "Agg: RX Provider",
        type: "number",
      },
      // End of aggregate_benefit nested object
      // specific_benefit nested object
      {
        key: "specific_benefit.blended_enrolled",
        name: "Spec Ben: Blended Enrolled",
        type: "number",
      },
      {
        key: "specific_benefit.contract_basis",
        name: "Spec Ben: Contract Basis",
        type: "number",
      },
      {
        key: "specific_benefit.contract_type",
        name: "Spec Ben: Contract Type",
        type: "number",
      },
      {
        key: "specific_benefit.covered_composite",
        name: "Spec Ben: Covered Composite",
        type: "number",
      },
      {
        key: "specific_benefit.eligible_expenses_incurred_end_date",
        name: "Spec Ben: Elligible Expenses Incurred End Date",
        type: "date",
      },
      {
        key: "specific_benefit.eligible_expenses_incurred_start_date",
        name: "Spec Ben: Elligible Expenses Incurred Start Date",
        type: "date",
      },
      {
        key: "specific_benefit.eligible_expenses_paid_end_date",
        name: "Spec Ben: Elligible Expenses Paid End Date",
        type: "date",
      },
      {
        key: "specific_benefit.eligible_expenses_paid_start_date",
        name: "Spec Ben: Elligible Expenses Paid Start Date",
        type: "date",
      },
      {
        key: "specific_benefit.families_enrolled",
        name: "Spec Ben: Families Enrolled",
        type: "number",
      },
      {
        key: "specific_benefit.individuals_enrolled",
        name: "Spec Ben: Individuals Enrolled",
        type: "number",
      },
      {
        key: "specific_benefit.is_aggregate_specific_deductible",
        name: "Spec Ben: Is Agg Specific Deductible",
        type: "boolean",
      },
      {
        key: "specific_benefit.is_specific_deductible",
        name: "Spec Ben: Is Specific Deductible",
        type: "boolean",
      },
      {
        key: "specific_benefit.maximum_specific_benefit",
        name: "Spec Ben: Maximum Specific Deductible",
        type: "number",
      },
      {
        key: "specific_benefit.has_medical_coverage",
        name: "Spec Ben: Medical Coverage",
        type: "number",
      },
      {
        key: "specific_benefit.medical_provider",
        name: "Spec Ben: Medical Provider",
        type: "number",
      },
      {
        key: "specific_benefit.has_rx_coverage",
        name: "Spec Ben: RX Coverage",
        type: "number",
      },
      {
        key: "specific_benefit.rx_provider",
        name: "Spec Ben: RX Provider",
        type: "number",
      },
      {
        key: "specific_benefit.specific_composite_premium",
        name: "Spec Ben: Specific Composite Premium",
        type: "number",
      },
      {
        key: "specific_benefit.specific_deductible",
        name: "Spec Ben: Specific Deductible",
        type: "number",
      },
      {
        key: "specific_benefit.specific_employee_plus_children_enrolled",
        name: "Spec Ben: Employee Plus Children Enrolled",
        type: "number",
      },
      {
        key: "specific_benefit.specific_employee_plus_children_premium",
        name: "Spec Ben: Employee Plus Children Premium",
        type: "number",
      },
      {
        key: "specific_benefit.specific_employee_plus_spouse_premium",
        name: "Spec Ben: Employee Plus Spouse Premium",
        type: "number",
      },
      {
        key: "specific_benefit.specific_family_premium",
        name: "Spec Ben: Family Premium",
        type: "number",
      },
      {
        key: "specific_benefit.specific_individual_premium",
        name: "Spec Ben: Individual Premium",
        type: "number",
      },
      {
        key: "specific_benefit.specific_maximum_reimbursement",
        name: "Spec Ben: Maximum Reimbursement",
        type: "number",
      },
      {
        key: "specific_benefit.specific_monthly_premium_rate",
        name: "Spec Ben: Monthly Premium Rate",
        type: "number",
      },
      {
        key: "specific_benefit.specific_stop_loss_percentage_reimbursable",
        name: "Spec Ben: Stoploss Percentage Reimbursable",
        type: "number",
      },
      // End of specific_benefit nested object
      // source_data nested object
      {
        key: "source_data.policyholder",
        name: "Source: Policyholder",
        type: "string",
      },
      {
        key: "source_data.policyholder_address",
        name: "Source: Policyholder Address",
        type: "string",
      },
      {
        key: "source_data.policyholder_affiliates",
        name: "Source: Policyholder Affiliates",
        type: "string",
      },
      {
        key: "source_data.policyholder_contact_email",
        name: "Source: Policyholder Contact Email",
        type: "string",
      },
      {
        key: "source_data.policyholder_contact_name",
        name: "Source: Policyholder Contact Name",
        type: "string",
      },
      {
        key: "source_data.policyholder_state",
        name: "Source: Policyholder State",
        type: "string",
      },
      {
        key: "source_data.policyholder_zip_code",
        name: "Source: Policyholder Zip Code",
        type: "string",
      },
      {
        key: "source_data.preferred_provider",
        name: "Source: Preferred Provider",
        type: "string",
      },
      {
        key: "source_data.state_of_issuance",
        name: "Source: State Of Issuance",
        type: "string",
      },
      {
        key: "source_data.stop_loss_carrier",
        name: "Source: Stop Loss Carrier",
        type: "string",
      },
      {
        key: "source_data.third_party_administrator",
        name: "Source: Third Party Administrator",
        type: "string",
      },
    ],
  },
  {
    id: ResourceName.CLIENTS,
    name: "Clients",
    editableKeys: [
      { key: "client_legal_name", name: "Legal Name", type: "string" },
      { key: "client_short_name", name: "Short Name", type: "string" },
      { key: "client_email", name: "Email Address", type: "string" },
      { key: "client_contact_name", name: "Contact Name", type: "string" },
      { key: "client_phone_no", name: "Phone Number", type: "string" },
      {
        key: "client_state_headquartered",
        name: "State Headquarters",
        type: "string",
      },
      { key: "client_parent_co", name: "Parent Company", type: "string" },
      {
        key: "calculations.amt_adjusted",
        name: "Amount Adjusted",
        type: "number",
      },
    ],
  },
  {
    id: ResourceName.TASKS,
    name: "Tasks",
    editableKeys: [],
  },
  {
    id: ResourceName.REIMBURSEMENTS,
    name: "Reimbursements",
    editableKeys: [
      {
        key: "adjustment_reason",
        name: "Adjustment Reason",
        type: "string",
      },
      {
        key: "auditor_name",
        name: "Auditor Name",
        type: "string",
      },
      {
        key: "claims_administrator",
        name: "Claims Administrator",
        type: "null",
      },
      {
        key: "denial_reason",
        name: "Denial Reason",
        type: "string",
      },
      {
        key: "payee",
        name: "Payee",
        type: "string",
      },
      {
        key: "pending_reason",
        name: "Pending Reason",
        type: "string",
      },
      {
        key: "provider",
        name: "Provider",
        type: "string",
      },
      {
        key: "service_end_date",
        name: "Service End Date",
        type: "string",
      },
      {
        key: "service_start_date",
        name: "Service Start Date",
        type: "string",
      },
      {
        key: "status",
        name: "Status",
        type: "select",
      },
    ],
  },
  {
    id: ResourceName.STOPLOSS_CLAIMS,
    name: "Stoploss Claims",
    editableKeys: [
      {
        key: "approved",
        name: "Approved",
        type: "text",
      },
      {
        key: "claim_status",
        name: "Claim Status",
        type: "select",
      },
      {
        key: "date_submitted",
        name: "Date Submitted",
        type: "date",
      },
      {
        key: "estimated_future_expenses",
        name: "Estimated Future Expenses",
        type: "number",
      },
      {
        key: "notes",
        name: "Notes",
        type: "string",
      },
      {
        key: "stoploss_claim_type",
        name: "Stoploss Claim Type",
        type: "string",
      },
    ],
  },
  {
    id: ResourceName.CLAIMANTS,
    name: "Claimants",
    editableKeys: [
      {
        key: "amt_incremental_lasered_deductible",
        name: "Incremental Lasered Deductible Amount",
        type: "number",
      },
      {
        key: "claimant_age",
        name: "Claimant Age",
        type: "number",
      },
      {
        key: "claimant_birth_date",
        name: "Claimant Date of Birth",
        type: "date",
      },
      {
        key: "claimant_first_name",
        name: "Claimant First Name",
        type: "string",
      },
      {
        key: "claimant_gender",
        name: "Claimant Gender",
        type: "string",
      },
      {
        key: "claimant_last_name",
        name: "Claimant Last Name",
        type: "string",
      },
      {
        key: "claimant_relationship",
        name: "Claimant Relationship",
        type: "string",
      },
      {
        key: "has_incremental_lasered_deductible",
        name: "Has Incremental Lasered Deductible",
        type: "boolean",
      },
      {
        key: "is_claimant_family_deductible",
        name: "Is Claimant Family Deductible",
        type: "boolean",
      },
      {
        key: "is_lasered",
        name: "Is Claimant Lasered",
        type: "boolean",
      },
      //eligibility nested object
      {
        key: "eligibility.cobra_effective_start_date",
        name: "Eligibility: Cobra Effective Start Date",
        type: "date",
      },
      {
        key: "eligibility.retirement_date",
        name: "Eligibility: Date Of Retirement",
        type: "date",
      },
      {
        key: "eligibility.is_cobra_applicable",
        name: "Eligibility: Is Cobra Applicable",
        type: "boolean",
      },
      {
        key: "eligibility.is_fmla_used",
        name: "Eligibility: Is Fmla Used",
        type: "boolean",
      },
      {
        key: "eligibility.is_actively_working",
        name: "Eligibility: Is Actively Working",
        type: "boolean",
      },
      {
        key: "eligibility.is_retired",
        name: "Eligibility: Is Retired",
        type: "boolean",
      },
      {
        key: "eligibility.is_sick_leave_used",
        name: "Eligibility: Is Sick Leave Used",
        type: "boolean",
      },
      {
        key: "eligibility.is_terminated",
        name: "Eligibility: Is Terminated",
        type: "boolean",
      },
      {
        key: "eligibility.is_vacation_leave_used",
        name: "Eligibility: Is Vacation Leave Used",
        type: "boolean",
      },
      {
        key: "eligibility.vacation_days_start_date",
        name: "Eligibility: Vacation Days Start Date",
        type: "date",
      },
    ],
  },
];

export const policyStatuses = [
  {
    id: "active",
    name: "Active",
  },
  {
    id: "draft",
    name: "Draft",
  },
  {
    id: "in_progress",
    name: "In Progress",
  },
  {
    id: "completed",
    name: "Completed",
  },
  {
    id: "cancelled",
    name: "Cancelled",
  },
  {
    id: "expired",
    name: "Expired",
  },
];

export const stoplossClaimStatuses = [
  {
    id: "open",
    name: "Open",
  },
  {
    id: "in_progress",
    name: "In Progress",
  },
  {
    id: "completed",
    name: "Completed",
  },
];

export const reimbursementStatuses = [
  {
    id: "pending",
    name: "Pending",
  },
  {
    id: "approved",
    name: "Approved",
  },
  {
    id: "denied",
    name: "Denied",
  },
  {
    id: "paid",
    name: "Paid",
  },
  {
    id: "adjusted",
    name: "Adjusted",
  },
  {
    id: "under_revied",
    name: "Under Review",
  },
];

export const policyColumns: { label: string; source: string }[] = [
  {
    label: "Policy Holder",
    source: "source_data.policyholder",
  },
  {
    label: "Policy Carrier",
    source: "source_data.policy_carrier",
  },
];

export const clientColumns: { label: string; source: string }[] = [
  {
    label: "Client Name",
    source: "client_legal_name",
  },
  {
    label: "Contact",
    source: "client_contact_name",
  },
];

export const taskColumns: { label: string; source: string }[] = [
  {
    label: "Title ",
    source: "title",
  },
  {
    label: "Description",
    source: "description",
  },
];

export const stoplossColumns: { label: string; source: string }[] = [
  {
    label: "Type",
    source: "stoploss_claim_type",
  },
  {
    label: "Notes",
    source: "notes",
  },
];

export const claimantColumns: { label: string; source: string }[] = [
  {
    label: "Claimant",
    source: "claimant_name",
  },
];

export const reimbursementColumns: { label: string; source: string }[] = [
  {
    label: "Provider",
    source: "provider",
  },
  {
    label: "Payee",
    source: "payee",
  },
];
